export class  RegionItemInfo  {

	constructor()
	{
		 this.region = null;
	}
	

	 static  GetRegionItemInfo(jsonObj)
		{	
			let itemInfo=null;
			if(jsonObj==null)return itemInfo;
			
			itemInfo=new RegionItemInfo();
			itemInfo.region =jsonObj.region;
			return itemInfo;	
		}

}//end RegionItemInfo

